import * as Yup from 'yup';
import { ObjectSchema } from 'yup';

export interface ICreateTicketInitialValues {
  title: string;
  description: string;
  companyId?: string;
}

export const createTicketValidationSchema = (
  isValidateCompany: boolean
): ObjectSchema<Partial<ICreateTicketInitialValues>> => Yup.object().shape({
  title: Yup.string().required('Required'),
  description: Yup.string().required('Required'),
  companyId: isValidateCompany ? Yup.string().required('Required') : Yup.string(),
});

export const createTicketInitialValues: ICreateTicketInitialValues = {
  title: '',
  description: '',
  companyId: undefined
};
